// import { fetchEventSource as fetchEventSourceOrigin } from '@microsoft/fetch-event-source';
import { fetchEventSource as fetchEventSourceOrigin } from 'libs/fetch-event-source/fetch';
import storage from "libs/storage";
import { StatusCode } from "./constant";
import { get } from "lodash";
import hrtpsLog from "@hrtps/log";
import { message } from 'antd'


message.config({
  top: 100,
  duration: 3,
  maxCount: 1
});


interface IData {
  reply: string;
  streamFinish: number;
}

const fetchEventSource = (params: any, callback: any, furl?:string) => {
  // const url =
  // 'https://test.ssc.hrtps.com/chatbot/api/chatStream'; // 本地框架原因，必须使用全路径才有流式效果
  // const url =
  //   'https://test.ssc.hrtps.com/chatbot/api/ssc-ai-server/chatStream/chat';
  const url = furl || '/chatbot/api/chatStream';
  const controller: any = new AbortController();
  const signal = controller.signal;
  hrtpsLog.info('fetchEventSourceLog',  {
    'Access-Token': storage.getToken(),
    'COMPANY_ID': storage.getCompanyID(),
    'body': JSON.stringify(params),
  })
  fetchEventSourceOrigin(url, {
    method: 'POST',
    signal,
    openWhenHidden: true,
    headers: {
      'Content-Type': 'application/json',
      'Access-Token': storage.getToken() || ''
    },
    body: JSON.stringify(params),
    onmessage(event: any) {
      if (controller) {
        const data = event.data ? JSON.parse(event.data) : {};
        const resMessage = data.message || data.reply || '处理异常';
        const code = get(data, 'code');
        if (code !== StatusCode.success) {
          message.error(resMessage);
          setTimeout(() => {
            window.location.reload();
          },2000)
          return;
        }

        callback(data);
        if (data.stream_finish === 1) {
          controller?.abort();
          return;
        }
      }
    },
    onerror(err) {
      if (controller) {
        controller?.abort();
        throw err;
      }
    }
  });
};

export default fetchEventSource;
